export default __webpack_public_path__ + "static/media/DocumentIcon.78a21746.svg";